export const THEME_ORDER = [
  'gelijke-kansen',
  'generatie',
  'natuur-klimaat',
  'identiteit',
  'lijf-hoofd',
];
